// test1588
(1588 && 0);
